const Cookies = require("js-cookie");

module.exports = {
  server: window.location.href.includes("localhost")
    ? "http://localhost:8000"
    : "https://api.hostarena.org",
  config: {
    headers: {
      Authorization: "Bearer " + Cookies.get("footprint"),
    },
  },
  RECAPTCHA_KEY: "6LfIAVMqAAAAAH_La4fo-S9qV3e9IufJX5S7bfSW",
  checkAccess: (err) => {
    if (err.response) {
      if (err.response.status === 401) {
        Cookies.remove("footprint");
        window.location.href = "/";
      }
    }
    return true;
  },
};
